import { Injectable, Injector } from "@angular/core";
import { LOCATION_INITIALIZED } from "@angular/common";
import { TranslateService } from "@ngx-translate/core";
import { SettingsService } from "./settings.service";

@Injectable({
  providedIn: "root",
})
export class TranslateLangService {
  constructor(
    private readonly injector: Injector,
    private readonly translate: TranslateService,
    private readonly settings: SettingsService
  ) {}

  load() {
    return new Promise<any>((resolve: any) => {
      const locationInitialized = this.injector.get(
        LOCATION_INITIALIZED,
        Promise.resolve(null)
      );
      locationInitialized.then(() => {
        const defaultLang = "en-US";

        this.settings.setLanguage(defaultLang);
        this.translate.setDefaultLang(defaultLang);
          this.translate.use(defaultLang).subscribe({
              next: () => { },
              error: () => {
                  console.error(
                      `Problem with '${defaultLang}' language initialization.'`
                  );
              },
              complete: () => {
                  resolve(null);
              }
          });
      });
    });
  }
}
